enum EServiceIDs {
    Auth = 1,
    Users = 2,
    GO = 3, // generators
    GT = 4, // green tools
    HD = 5, // helpdesk
    Content = 6,
    Billing = 7,
    Fuel = 8,
    CA = 9, // commercial accounting
    GA = 10, // generation attributes
    Settings = 11
}

export {EServiceIDs}